export const appConfig = { region: 'ap-northeast-1', userPoolId: 'ap-northeast-1_Ix5H6KxXX',
userPoolClientId: '59mhq5vh2cgh9dp3orh95bm7k3',
  apiUrl: 'https://develop.jp.test.vgs-dxone.com', wssUrl: 'wss://develop.jp.test.vgs-dxone.com/wss',
};